export class ChatbotSettingsService {
    static $inject = ['BucketService'];
    constructor(BucketService) {
        this.BucketService = BucketService;
    }
    async isBuilderActive(application) {
        if (!ChatbotSettingsService.TEMPLATES.includes(application.template)) {
            return false;
        }
        return await this.getBooleanValue(ChatbotSettingsService.BUILDER_ENABLED_KEY);
    }
    async setBuilderActive(application, active) {
        switch (application.template) {
            case 'builder':
            case 'pipeline':
                await this.setBooleanValue(ChatbotSettingsService.BUILDER_ENABLED_KEY, active);
                break;
            default:
                return;
        }
    }
    async isHttpActive(application) {
        return await this.getBooleanValue(ChatbotSettingsService.HTTP_ENABLED_KEY);
    }
    async setHttpActive(application, active) {
        await this.setBooleanValue(ChatbotSettingsService.HTTP_ENABLED_KEY, active);
    }
    async getBooleanValue(key) {
        try {
            const value = await this.BucketService.get(this.getBucketKey(key));
            return value == 'True';
        }
        catch (e) {
            return false;
        }
    }
    async setBooleanValue(key, value) {
        await this.BucketService.set(this.getBucketKey(key), value, 'text/plain');
    }
    getBucketKey(key) {
        return `${ChatbotSettingsService.KEY_PREFIX}:${key}`;
    }
}
ChatbotSettingsService.KEY_PREFIX = 'blip_portal';
ChatbotSettingsService.BUILDER_ENABLED_KEY = 'builder_enabled';
ChatbotSettingsService.HTTP_ENABLED_KEY = 'http_enabled';
ChatbotSettingsService.TEMPLATES = ['builder', 'pipeline'];
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
ChatbotSettingsService.$inject = ['BucketService'];
